<script setup lang="ts">
import {computed, onMounted, onUnmounted} from "vue";
import Translator from "@/utils/common/Translator.ts";
import GeneralAnnouncementsUtil from "@/utils/common/GeneralAnnouncementsUtil.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import MegaphoneIcon from "@/components/announcements/MegaphoneIcon.vue";
import AnnouncementDots from "@/components/announcements/AnnouncementDots.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const index = GeneralAnnouncementsUtil.index;
const current = computed(() => GeneralAnnouncementsUtil.current());
const total = computed(() => GeneralAnnouncementsUtil.announcements.value.length);

onMounted(() => GeneralAnnouncementsUtil.startRotation());
onUnmounted(() => GeneralAnnouncementsUtil.stopRotation());
</script>

<template>
  <div v-if="current" :key="index" :dir="Translator.fetchDir()"
       class="tw-flex tw-flex-col tw-gap-[3px] tw-w-full tw-pt-3 tw-px-3.5 tw-pb-3.5
              tw-bg-[image:linear-gradient(180deg,#f5f9ff,#eef5ff)] dark:tw-bg-[image:linear-gradient(180deg,rgba(37,99,235,.17),rgba(37,99,235,.06))] tw-animate-[annIn_.3s_ease_both]
              tw-border-b tw-border-b-namaBackground-bright-light dark:tw-border-b-namaBackground-bright-dark
              tw-border-s-[3px] tw-border-s-primary-light dark:tw-border-s-primary-dark">
    <div class="tw-flex tw-items-center tw-gap-2.5 tw-w-full tw-justify-between">
      <div class="tw-flex tw-gap-2 tw-px-1.5 tw-py-0.5 tw-rounded-[9px] tw-text-xs
                  tw-bg-gray-200 dark:tw-bg-gray-600 tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark">
        <MegaphoneIcon :size="18" class="tw-fill-primary-light dark:tw-fill-primary-dark"/>
        <span class="tw-flex tw-items-center tw-justify-center tw-w-fit tw-h-fit"
              v-text="Translator.translateId(BSCEntities.GeneralAnnouncement + 's')"/>
      </div>
      <div v-if="total > 1" class="tw-flex tw-gap-2">
        <AnnouncementDots/>
        <div class="tw-flex tw-flex-none tw-gap-1">
          <div class="tw-size-6 tw-rounded-md tw-border tw-border-[#aab8d0] dark:tw-border-[#6d798b]
                      tw-text-base tw-cursor-pointer tw-flex tw-items-center tw-justify-center
                      tw-text-[#4b5563] dark:tw-text-[#d5dce6] hover:tw-bg-[#c2c8d2] dark:hover:tw-bg-[#5d6877]
                      hover:tw-text-[color:var(--nama-primary-light)] dark:hover:tw-text-[color:color-mix(in_srgb,var(--nama-primary-dark)_40%,white)]"
               :title="Translator.translateId('previous')"
               @click="GeneralAnnouncementsUtil.previous()">
            <NamaIcon default-icon="nm-next" class="!tw-size-3 dark:!tw-fill-white !tw-fill-gray-500"/>
          </div>
          <div class="tw-size-6 tw-rounded-md tw-border tw-border-[#aab8d0] dark:tw-border-[#6d798b]
                      tw-text-base tw-cursor-pointer tw-flex tw-items-center tw-justify-center
                      tw-text-[#4b5563] dark:tw-text-[#d5dce6] hover:tw-bg-[#c2c8d2] dark:hover:tw-bg-[#5d6877]
                      hover:tw-text-[color:var(--nama-primary-light)] dark:hover:tw-text-[color:color-mix(in_srgb,var(--nama-primary-dark)_40%,white)]"
               :title="Translator.translateId('next')"
               @click="GeneralAnnouncementsUtil.next()">
            <NamaIcon default-icon="nm-next" class="!tw-size-3 tw-rotate-180 dark:!tw-fill-white !tw-fill-gray-500"/>
          </div>
        </div>
      </div>
    </div>
    <div class="tw-flex-none tw-w-full tw-max-h-[140px] tw-overflow-y-auto !tw-overflow-x-hidden
                [overflow-wrap:anywhere] tw-text-sm tw-font-bold tw-leading-5
                tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark"
         :title="current.text" data-scrollbar-reveal v-text="current.text"/>
  </div>
</template>
